var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number-card',{attrs:{"amount":_vm.amount,"title":_vm.$it('dealer.audits.content.title', 'Satisfactory'),"success":""}})}
var staticRenderFns = []

export { render, staticRenderFns }